const Colors = {
    background: {
        mainDark: '#312f3d',
        light: '#FFFFF',
    },
    main: {
        primary: '#ff5a60',
        active: '#c93d42',
    },
    text: {
        light: '#FFFF',
        error: '#e52e33',
    },
};

export default Colors;
